import styled from 'styled-components'
import { TestWrapperProps } from './typings'

export const TestWrapper = styled.div<TestWrapperProps>`
  margin-top: ${({ isPractice }) => (isPractice ? '0' : '32px')};
`

export const TestListWrapper = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: row;
  justify-content: left;
  flex-wrap: wrap;
  height: auto;
`
